import React from 'react';
import { resolveNewsCategoryIcon } from '../config/categoryIcons';

const CategoryIcon = ({ news }) => {
  const resolved = resolveNewsCategoryIcon(news);

  if (!resolved.src) {
    return (
      <span className="news-category-general news-category-general--fallback">
        {resolved.label}
      </span>
    );
  }

  return (
    <span
      className="news-category-general news-category-general--icon"
      title={resolved.label}
      aria-label={resolved.label}
    >
      <img src={resolved.src} alt="" />
    </span>
  );
};

export default CategoryIcon;
